import { generateMutationsFor } from '@/store/tools'

let mutations = [
  'SET_BUILDING_LIST',
  'ADD_BUILDING',
  'UPDATE_BUILDING',
  'DELETE_BUILDING'
]

export default generateMutationsFor(mutations)
